import PropTypes from 'prop-types'
import accounting from 'accounting'
import styles from './index.module.scss'
import { Button, Card, Col, Image } from 'antd'
import Link from 'next/link'

export default function Index ({
  product,
  mode = 'big',
  isRecentOrder = false,
  paidPrice = 0
}) {
  return (
    <>
      {(product && mode === 'big') &&
        <Col className={`${styles.big} shadow`} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
          <Card className={styles.main}
            cover={<img className={styles.image} alt={product.name} src={product.image_url}/>
            }>
            {product.is_new && <div className={styles.newTag}><h1 size='18px' color='white'>NEW</h1></div>}
            <div className={styles.name}>{product.name}</div>
            <div className={styles.supercard}>{product.is_super_card_exclusive && <img src='/images/supercard_v2/sc-icon-v2.png' alt='' />}</div>
            <div className={styles.description} dangerouslySetInnerHTML={{ __html: product.description }} />
            <div className={styles.price} size='large'>
              <div className={styles.price_label}></div>
              <div className={styles.price_value}>{accounting.formatMoney(product.price, '₱', 2)}</div>
            </div>
            <Link href={'/catalog/' + product.id}>
              <a><Button className={styles.order} type='primary'>Order</Button></a>
            </Link>
          </Card>
        </Col>}
      {(product && mode === 'small') &&
        <Link href={'/catalog/' + product.id}>
          <Col className={styles.small} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
            <Card className={styles.main}>
              <div className={styles.image}><img alt={product.name} src={product.image_url}/></div>
              {product.is_new && <div className={styles.newTag}><Image src='/images/New-Ribbon2.png' alt='' preview={false} /></div>}
              <h4 className='name' style={{ color: 'var(--cognac)', lineHeight: '22px', paddingTop: '0' }}>{product.name}</h4>
              <div className={styles.supercard}>{product.is_super_card_exclusive && <img src='/images/supercard_v2/sc-icon-v2.png' alt='' />}</div>
              <div className={styles.description} dangerouslySetInnerHTML={{ __html: product.description }} />
              <Link href={'/catalog/' + product.id}>
                <a><Button className={styles.order} type='primary'>{isRecentOrder ? 'Re-Order' : 'Order'}</Button></a>
              </Link>
              <div className={styles.price} size='large'>
                <div className={styles.price_value}><a>{accounting.formatMoney(isRecentOrder ? paidPrice : product.price, '₱', 2)}</a></div>
              </div>
            </Card>
          </Col>
        </Link>
      }
    </>
  )
}

Index.propTypes = {
  product: PropTypes.object,
  mode: PropTypes.string,
  isRecentOrder: PropTypes.bool,
  paidPrice: PropTypes.number
}
